

export function ModalReducer(state, action) {
    const Component = action['compnent']

    return(
        <Component></Component>
    )
}